class Tracker {
  private shouldTrack = true;

  set shouldTrackSegmentView(newValue) {
    this.shouldTrack = newValue;
  }

  get shouldTrackSegmentView(): boolean {
    return this.shouldTrack;
  }
}

export const SegmentViewedTracker = new Tracker();
